/**
 * Routes whose page component is a separate webpack chunk.
 * `chunk` must match the webpackChunkName in publicPageRegistry.js.
 * The prerender script reads this file to emit a matching <link rel="preload">.
 */

const PUBLIC_PAGES = [
  { name: 'contact', chunk: 'page-contact', match: (path) => path === '/contact' },
  { name: 'about', chunk: 'page-about', match: (path) => path === '/about' },
  { name: 'offers', chunk: 'page-offers', match: (path) => path === '/offers' },
  { name: 'blogs', chunk: 'page-blogs', match: (path) => path === '/blogs' },
  { name: 'blogPost', chunk: 'page-blog-post', match: (path) => path.startsWith('/blogs/') },
  { name: 'technicianApply', chunk: 'page-technician-apply', match: (path) => path === '/technician/apply' },
  { name: 'servicesIndex', chunk: 'page-services', match: (path) => path === '/services' },
  {
    name: 'serviceDetail',
    chunk: 'page-service',
    match: (path) => path.startsWith('/services/') && path !== '/services/search',
  },
  { name: 'city', chunk: 'page-city', match: (path) => path.startsWith('/cities/') },
];

function normalizePath(pathname) {
  const pathOnly = String(pathname || '').split('?')[0].split('#')[0];
  if (pathOnly.length > 1 && pathOnly.endsWith('/')) return pathOnly.slice(0, -1);
  return pathOnly || '/';
}

function publicPageForPath(pathname) {
  const path = normalizePath(pathname);
  return PUBLIC_PAGES.find((page) => page.match(path)) || null;
}

module.exports = {
  PUBLIC_PAGES,
  publicPageForPath,
};
